// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { i18n } from '@/plugins/i18n'


import VueAnalytics from 'vue-analytics';
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-137275240-1'
})


import BvueUi from '@bvapps/bvue-ui'
Vue.use(BvueUi)

import BvueI18n from '@bvapps/bvue-i18n'
import langEs from './locales/es'
import langEn from './locales/en'
Vue.use(BvueI18n, {
  ES: langEs,
  EN: langEn
})

import VueSimpleSVG from 'vue-simple-svg'
Vue.use(VueSimpleSVG)

import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'
Vue.use(SlimDialog)

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBzlLYISGjL_ovJwAehh6ydhB56fCCpPQw',
    key: 'AIzaSyCvR-jh3JfnnsQLSB-hqWR79mJZvjERMQQ'
  },
})

import GmapCluster from 'vue2-google-maps/dist/components/cluster'
Vue.component('GmapCluster', GmapCluster)

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount()





// WEBPACK FOOTER //
// ./src/main.js